import styled, { css } from 'styled-components'

import FormLabel from '../FormLabel'

export const Container = styled.div<{ $isDisabled?: boolean }>`
  display: flex;
  flex-flow: column;

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.4;
    `}
`

export const Label = styled(FormLabel)`
  margin-bottom: 5px;
`

export const Input = styled.input<{
  $isError?: boolean
  $isDisabled?: boolean
}>`
  ${({ theme }) => theme.textStyles.text}
  color: ${({ theme }) => theme.colors.pureBlack};
  width: 100%;
  padding: 12px;
  background: none;
  border: 1px solid ${({ theme }) => theme.colors.pureBlack};

  ${({ $isError, theme }) =>
    $isError &&
    css`
      color: ${theme.colors.red};
      border-color: ${theme.colors.red};
    `};

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      cursor: not-allowed;
    `};

  &[readonly] {
    cursor: default;
  }

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: grey;
  }
`

export const Help = styled.p`
  ${({ theme }) => theme.textStyles.tiny}
  color: grey;
  margin-top: 5px;
`

export const Error = styled.p`
  ${({ theme }) => theme.textStyles.tiny}
  color: ${({ theme }) => theme.colors.red};
  margin-top: 5px;
`
